'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/~/dom-helpers/util/inDOM.js
// module id = 135
// module chunks = 0